import { withTheme } from '../config';
import { SearchBar, } from '@rneui/base/dist/SearchBar/SearchBar';
export { SearchBar };
export default withTheme(SearchBar, 'SearchBar');
